// extracted by mini-css-extract-plugin
export default {"modal":"kea-z","modalContent":"lea-z","footer":"mea-z","cancelBtn":"nea-z","disabled":"oea-z","formWrapper":"pea-z","fade":"qea-z","fade-in":"rea-z","iframe":"sea-z"};